export const API_ERRORS = {
  INCORRECT_CREDENTIALS: 'Incorrect username or password',
  INVALID_CONFIRMATION_CODE: 'Invalid confirmation code',
  INVALID_MFA_CODE: 'Invalid MFA code',
  RACE_CONDITION_ELIGIBILITY_CHECKLIST:
    'A check for this criterion already exists for this patient',
  AUTH_SESSION_EXPIRED: 'Auth session expired',
  TOO_MANY_ATTEMPTS: 'Too many requests. Please try again later',
  CODE_EXPIRED: 'Confirmation code has expired',
  CO_INVESTIGATOR_CHECKS_MISSING:
    'Co-Investigator must complete all criterion verifications before approving overall eligibility.',
  WRONG_PROCEDURE_DATE: 'Procedures can only be joined on the scheduled procedure date',
} as const;

export const API_ERROR_KEYS = {
  [API_ERRORS.INCORRECT_CREDENTIALS]: 'incorrectCredentials',
  [API_ERRORS.INVALID_CONFIRMATION_CODE]: 'invalidConfirmationCode',
  [API_ERRORS.INVALID_MFA_CODE]: 'invalidMfaCode',
  [API_ERRORS.RACE_CONDITION_ELIGIBILITY_CHECKLIST]:
    'raceConditionEligibilityChecklist',
  [API_ERRORS.CODE_EXPIRED]: 'codeExpired',
  [API_ERRORS.CO_INVESTIGATOR_CHECKS_MISSING]: 'coInvestigatorChecksMissing',
  [API_ERRORS.WRONG_PROCEDURE_DATE]: 'wrongProcedureDate',
} as const;

// Type for the raw error messages from the backend
export type ApiErrorMessage = keyof typeof API_ERROR_KEYS;
